import React, { ComponentProps } from "react";
// eslint-disable-next-line no-restricted-imports
import { Spinner as BSSpinner } from "react-bootstrap";

// react-bootstrap's Spinner component has a prop called "animation" that is required.
// We want to make it optional, and also set a default value.
type BSSpinnerProps = ComponentProps<typeof BSSpinner>;
type SpinnerProps = Omit<BSSpinnerProps, "animation"> & Partial<Pick<BSSpinnerProps, "animation">>;

export const Spinner: React.FC<SpinnerProps> = ({
  animation = "border",
  style = {},
  ...props
}) => {
  return (
    <BSSpinner
      role="status"
      data-fb-panel="spinner"
      data-testid="spinner"
      animation={ animation }
      style={ {
        animationDuration: "2s",
        ...style
      } }
      { ...props }
    />
  );
};
